<template>
  <div class="d-inline">
    <v-tooltip v-if="variant === 'fab'" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="sync"
          :disabled="loading"
          x-small
          fab
          color="secondary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon :class="{ 'mdi-spin': loading }">
            mdi-sync
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Sync with Google') }}</span>
    </v-tooltip>

    <v-list-item
      v-else
      @click="sync"
      :disabled="loading"
      :class="menuItemClass"
    >
      <v-list-item-icon class="mr-2">
        <v-icon
          color="secondary"
          :class="{ 'mdi-spin': loading }"
        >
          mdi-sync
        </v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ $t('Sync with Google') }}
      </v-list-item-title>
    </v-list-item>

    <modal
      :show="showSyncErrorModal"
      :title="$t('google_place_sync_error')"
      :description="$t('Too many requests')"
      save-text="Close"
      @close="showSyncErrorModal = false"
      @save="showSyncErrorModal = false"
      :hide-actions-cancel="true"
      max-width="500"
    />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    placeId: {
      required: true,
    },
    variant: {
      type: String,
      default: 'fab',
    },
    menuItemClass: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      showSyncErrorModal: false,
    };
  },
  methods: {
    sync() {
      this.loading = true;
      this.$store.dispatch('loading', true);

      axios.get(`panel/ads/places/${this.placeId}/sync`)
        .then(() => {
          this.$store.dispatch('message', this.$t('google_place_sync_success'));
          this.$emit('synced');
        })
        .catch((error) => {
          if (error.response && error.response.status === 429) {
            this.showSyncErrorModal = true;
          } else {
            this.$store.dispatch('message', this.$t('google_place_sync_error'));
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('loading', false);
        });
    },
  },
};
</script>
